import { render } from "./shareRedirect.vue?vue&type=template&id=0046e391&scoped=true"
import script from "./shareRedirect.vue?vue&type=script&lang=js"
export * from "./shareRedirect.vue?vue&type=script&lang=js"

import exportComponent from "F:\\webStorm workspace\\ujk_tangying\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0046e391"]])

export default __exports__